import { toMilliseconds } from '@art-suite/art-core-ts';

/**
 * Cache entry structure with JSON value and expiration metadata
 */
export interface TypedCacheEntry<ValueType extends unknown, TransientDataType extends unknown = undefined> {
  key: string;
  createdAt: number;
  expiresAt: number;
  value: ValueType;
  transientData?: TransientDataType;
}
export type PromisedTypedCacheEntry<ValueType extends unknown> = Promise<TypedCacheEntry<ValueType>>;
export type CacheEntry = TypedCacheEntry<unknown>;

export type CacheEntryMetadata = TypedCacheEntry<undefined>;

export const isCacheEntryExpired = (entry: CacheEntry, now?: number): boolean => toMilliseconds(now) > entry.expiresAt;
